import { supabase } from '@/lib/supabase'
import type { RecipeFormData } from '@/types/recipe'

export const requireSessionUser = async () => {
  const { data, error } = await supabase.auth.getUser()
  if (error) {
    throw error
  }

  if (!data.user) {
    throw new Error('Not authenticated')
  }

  return data.user
}

export const mapRecipeInput = (recipe: Partial<RecipeFormData>, userId?: string) => ({
  ...(userId ? { user_id: userId } : {}),
  ...(recipe.title !== undefined ? { title: recipe.title } : {}),
  ...(recipe.description !== undefined ? { description: recipe.description || null } : {}),
  ...(recipe.ingredients !== undefined ? { ingredients: recipe.ingredients } : {}),
  ...(recipe.instructions !== undefined ? { instructions: recipe.instructions } : {}),
  ...(recipe.prep_time !== undefined ? { prep_time: recipe.prep_time } : {}),
  ...(recipe.cook_time !== undefined ? { cook_time: recipe.cook_time } : {}),
  ...(recipe.servings !== undefined ? { servings: recipe.servings } : {}),
  ...(recipe.difficulty !== undefined ? { difficulty: recipe.difficulty || null } : {}),
  ...(recipe.meal_type !== undefined ? { meal_type: recipe.meal_type || null } : {}),
  ...(recipe.tags !== undefined ? { tags: recipe.tags } : {}),
  ...(recipe.equipment !== undefined ? { equipment: recipe.equipment } : {}),
  ...(recipe.image_url !== undefined ? { image_url: recipe.image_url || null } : {}),
  ...(recipe.rating !== undefined ? { rating: recipe.rating } : {}),
  ...(recipe.notes !== undefined ? { notes: recipe.notes || null } : {}),
  ...(recipe.household_id !== undefined ? { household_id: recipe.household_id || null } : {}),
  ...(recipe.is_public !== undefined ? { is_public: recipe.is_public } : {}),
  ...(recipe.is_curated !== undefined ? { is_curated: recipe.is_curated } : {}),
})

export const sortNewestFirst = <T extends { created_at: string }>(items: T[]) =>
  [...items].sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
